import { useState } from "react";
import LearningMetrics from "./LearningMetrics";
import ProfileMetrics from "./ProfileMetrics";
import ProjectMetrics from "./ProjectMetrics";
import ProjectsList from "./ProjectsList";
import SignatureCapture from "../../widgets/captures/SignatureCapture";
import { FIELD_TYPES, FieldItem } from "../../widgets/fields";
import LocationCapture from "../../widgets/captures/LocationCapture";

export default function Dashboard() {
  const [action, setAction] = useState<string>("");
  const [selectedProjectStage, setSelectedProjectStage] = useState<any>("");
  const inDevelopement = true;
  const sampleData = [
    {
      stage: "Stage 1",
      projects: [{ name: "project 1" }, { name: "project 2" }, { name: "project 3" }],
    },
    {
      stage: "Stage 2",
      projects: [
        { name: "project 1" },
        { name: "project 2" },
        { name: "project 3" },
        { name: "project 4" },
        { name: "project 5" },
      ],
    },
    {
      stage: "Stage 3",
      projects: [{ name: "project 1" }, { name: "project 2" }],
    },
  ];

  const onAction = async (type: string, data: any = null) => {
    if (type === "projectslist") {
      const stageData = sampleData.find((item) => item.stage === data);
      setSelectedProjectStage(stageData);
    }
    setAction(type);
  };

  if(inDevelopement){
    return <div>Dashboard</div>
  }

  

  const handleUpload = (file: File | string) => {
    // Handle file upload logic (e.g., send to server or convert to base64)
    console.log('File uploaded:', file);
  };

  const elements = {
    signatureComp: {
      name: "signatureComp",
      type: FIELD_TYPES.SIGNATURE_CAPTURE,
      isMandatory: false,
  },
  imageComp: {
    name: "signatureComp",
    type: FIELD_TYPES.IMAGE_CAPTURE,
    isMandatory: false,
  },
  videoComp: {
    name: "signatureComp",
    type: FIELD_TYPES.VIDEO_CAPTURE,
    isMandatory: false,
  },
  audioComp: {
    name: "signatureComp",
    type: FIELD_TYPES.AUDIO_CAPTURE,
    isMandatory: false,
  }
  }


  return (
    <>
    <div>
      <LocationCapture />
    </div>
    {/* <div>
      <h1>Signature Capture</h1>
      <SignatureCapture
        onUpload={handleUpload}
      />
    </div> */}
    
    {/* <div>
      <h1>Video Capture</h1>
      <VideoCapture
      />
    </div> */}
    {/* <div>
    <h1>Signature Capture</h1>
     <FieldItem 
      {...elements.signatureComp}
      onChange={(...e)=>{
        console.log(e[0])
      }}
     />
    </div>
    <div>
      <h1>Image Capture</h1>
      <FieldItem 
      {...elements.imageComp}
      onChange={(...e)=>{
        console.log(e)
      }}
     />
    </div>
    <div>
      <h1>Video Capture</h1>
      <FieldItem 
      {...elements.videoComp}
      onChange={(...e)=>{
        console.log(e)
      }}
     />
    </div> *
     <div>
      <h1>Audio Capture</h1>
      <FieldItem 
      {...elements.audioComp}
      onChange={(...e)=>{
        console.log(e)
      }}
     />
    </div> */}
      <div className="dashboard-container__header">Dashboard</div>
      {action === "" && (
        <div className="dashboard-container">
          <div className="dashboard-container__content">
            <div className="dashboard-container__content__left-column">
              <ProfileMetrics />
              <LearningMetrics />
            </div>
            <div className="dashboard-container__content__right-column">
              <ProjectMetrics onAction={onAction} data={sampleData} />
            </div>
          </div>
        </div>
      )}
      {action === "projectslist" && (
        <div className="dashboard-container__project-list-container">
          <ProjectsList selectedProjectStage={selectedProjectStage} onClose={() => onAction("")} />
        </div>
      )}
    </>
  );
}
